import { Box, Divider, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { VerifyCodeForm } from "components/authentication/verify-code/VerifyCodeForm";

export const VerifyCodeStep: React.FC<{
  loginValues: { email: string; password: string };
}> = ({ loginValues }) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <div>
          <Typography color="textPrimary" gutterBottom variant="h4">
            {t("verify_code.title")}
          </Typography>
          <Typography color="textSecondary" variant="body2">
            {t("verify_code.subtitle")}
          </Typography>
        </div>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          mt: 3,
        }}
      >
        <VerifyCodeForm loginValues={loginValues} />
      </Box>
      <Divider sx={{ my: 3 }} />
      <Link color="textSecondary" variant="body2">
        {t("verify_code.send_again")}
      </Link>
    </>
  );
};
